import $ from "jquery";
import Screen from "@bd-utils/screen";
import CONFIG from "@bd-core/config";
import BD_Component from "@bd-core/bd-component";
import compile from "@bd-utils/handlerbars-helper";
import { getRoomAnswerById } from "@bd-stores/game-data";
import { getRoomStatus, getFinalTeamAnswers } from "@bd-stores/game-progress";
import {
    saveFinalRoomAnswers,
    maybeUpdateRoomStatus,
} from "@bd-core/firebase-actions";

export class RoomCluesEquationsPlus extends BD_Component {
    constructor() {
        super();

        this.id = "clues_equations_plus";
        this.templateID = "clues_equations_plus-template";

        this.elms = {
            checkState: ".js-check-state",
            checkAnswer: ".js-check",
            inputWrapper: ".js-input-wrapper",
            input: ".js-input",
            clue: ".js-clue",
            clueOnShelf: ".js-clue-shelf",
            closeBtn: ".js-question-close",
            autofill: ".js-autofill",
        };

        this._events = this.getEvents();

        this.right_coordinates = [
            { top: 25.4, left: 78.6 },
            { top: 49.5, left: 64.8 },
            { top: 16, left: 59.3 },
            { top: 16, left: 71 },
            { top: 30, left: 61 },
            { top: 43, left: 79 },
            { top: 58, left: 54 },
            { top: 46, left: 73 },
        ];

        this.left_coordinates = [
            { top: 26.4, left: 28.7 },
            { top: 27.4, left: 35 },
            { top: 40.6, left: 28.7 },
            { top: 41, left: 34.9 },
            { top: 55, left: 28.7 },
            { top: 54.9, left: 34.9 },
            { top: 69.5, left: 28.7 },
            { top: 68.7, left: 35.2 },
        ];
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "input",
                selector: elms.input,
                handler: this.inputAnswer,
            },
            {
                event: "click",
                selector: elms.checkAnswer,
                handler: this.checkAnswer,
            },
            {
                event: "mouseenter",
                selector: elms.clue,
                handler: this.setPopupOver,
            },
            {
                event: "mouseleave",
                selector: elms.clue,
                handler: this.setPopupUnder,
            },
            {
                event: "click",
                selector: elms.closeBtn,
                handler: this.closePopup,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
    }

    getDataWithCoordinates() {
        /**
         * @type {{ boxes?: any, clues?: any }}
         */
        const modified = { ...this._data };
        const rightCoordinates = this.right_coordinates;
        const leftCoordinate = this.left_coordinates;
        const countBoxes = this._data.boxes.length;

        const defaultImageBg = `${CONFIG.themeURL}/assets/images/bg-clues-equations-plus.png`;

        const _image_bg = this._data.image_bg
            ? this._data.image_bg
            : defaultImageBg;

        const modifiedBoxes = this._data.boxes.map((box, i) => ({
            ...box,
            cssTop: leftCoordinate[i].top,
            cssLeft: leftCoordinate[i].left,
            htmlDataIndex: i,
        }));

        const modifiedClues = this._data.clues.map((clue, i) => ({
            ...clue,
            cssTop: rightCoordinates[i].top,
            cssLeft: rightCoordinates[i].left,
            htmlDataIndex: i + countBoxes,
        }));

        const hintHotspots = this._data.hotspots.filter(
            (hotspot) => hotspot["hotspot_type"] === "hint",
        );

        const hotspotCount = hintHotspots.length;
        const defaultValue = "50%";
        const modifiedHint = this._data.hints.map((hint, i) => {
            const font_fam = hint.hint_font_family.split("|");
            const font_name = font_fam[0];
            const font_category = font_fam[1];

            return {
                ...hint,
                font_family: `"${font_name}", ${font_category}`,
                has_image: hint.image,
                position_top:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_top
                        : defaultValue,
                position_left:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_left
                        : defaultValue,
            };
        });

        const modifiedData = {
            ...modified,
            hints: modifiedHint,
            boxes: modifiedBoxes,
            clues: modifiedClues,
            image_bg: _image_bg,
        };

        return modifiedData;
    }

    render() {
        const data = this.getDataWithCoordinates();
        const isForcedOpenChallenge = data["force_open_challenge"];

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, data);
        $(".app").html(html);
        window.screenCalculationFunc = () => Screen.calculateFitSize();

        if (isForcedOpenChallenge) {
            // this.onForceOppenChallenge();
        }
    }

    onForceOppenChallenge() {}

    setGameState() {
        const elms = this.elms;
        const roomID = this.roomId;
        const thisRoomStatus = getRoomStatus(roomID);
        const roomAnswers = getFinalTeamAnswers(roomID);

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        if (thisRoomStatus !== "is-status-completed") {
            const getBrowserType = (browserString) => {
                return (
                    navigator.userAgent.toLowerCase().indexOf(browserString) >
                    -1
                );
            };

            /* check browser type to set autocomplete attribute on/off
             so that datalist can works well in all browser */
            const isFirefox = getBrowserType("firefox");

            if (!isFirefox) $(elms.input).attr("autocomplete", "off");
        }

        if (roomAnswers) {
            $.each(roomAnswers, function (index, answer) {
                $(`input[name=${index}]`).prop("readonly", true).val(answer);
            });
        }

        if (thisRoomStatus == "is-status-completed") {
            $(elms.checkState).addClass("is-completed");
            $(elms.input).prop("readonly", true);
            $(elms.checkAnswer).prop("disabled", true);
            $(".app__page").addClass("is-room-completed");
        }

        const $shelfClues = $(elms.clueOnShelf);
        $.each($shelfClues, (index, shelfClue) => {
            const $clue = $(shelfClue);

            $clue.on("mouseenter", () => {
                $clue.next().addClass("is-open");
            });

            $clue.on("mouseleave", () => {
                $clue.next().removeClass("is-open");
            });

            $clue.next().on("mouseenter", function () {
                $(this).addClass("is-open");
            });

            $clue.next().on("mouseleave", function () {
                $(this).removeClass("is-open");
            });
        });
    }

    // ============================== CUSTOM FUNCTION

    setPopupOver() {
        const elms = this.elms;
        $(elms.checkState).css("z-index", "-1");
    }

    setPopupUnder() {
        const elms = this.elms;
        $(elms.checkState).css("z-index", "0");
    }

    inputAnswer(e, el) {
        e.preventDefault();

        const $this = $(el);

        const elms = this.elms;
        const autofillID = $this.attr("list");
        const $questionWrapper = $(elms.checkState);
        const isCompleted = $questionWrapper.hasClass("is-completed");

        if (isCompleted) {
            return false;
        }

        if (String($this.val()).trim() !== "") {
            $(elms.autofill).attr("id", autofillID);
        } else {
            $(elms.autofill).attr("id", "");
        }

        $questionWrapper.removeClass("is-incorrect");
        this.toggleCheckButton();
    }

    closePopup(e) {
        e.preventDefault();

        const elms = this.elms;
        const $questionWrapper = $(elms.checkState);

        $questionWrapper.removeClass("is-checked");
    }

    toggleCheckButton() {
        const elms = this.elms;
        const $checkBtn = $(elms.checkAnswer);
        const $answers = $(elms.input);
        let isAllAnswered = true;

        $.each($answers, function (index, answer) {
            const $answer = $(answer);
            const value = String($answer.val());

            if (value.trim() == "") {
                isAllAnswered = false;
                return false;
            }
        });

        return isAllAnswered
            ? $checkBtn.removeAttr("disabled")
            : $checkBtn.prop("disabled", true);
    }

    checkAnswer(e, el) {
        const $el = $(el);
        const elms = this.elms;
        const $questionWrapper = $el.parents(elms.checkState);

        if ($el.hasClass("is-loading") || $el.hasClass("is-completed")) return;

        $el.addClass("is-loading").prop("disabled", true);
        $questionWrapper.removeClass("is-checked is-correct is-incorrect");

        const leftAnswer = String($('input[name="left"]').val()).toLowerCase();
        const rightAnswer = String(
            $('input[name="right"]').val(),
        ).toLowerCase();

        const roomID = this.roomId;
        let roomStatus = "is-status-started";
        const correctAnswers = getRoomAnswerById(roomID);
        let isCorrect = false;
        const playerAnswer = {};

        const checkLeftInLeft = $.inArray(leftAnswer, correctAnswers.left);

        if (checkLeftInLeft > -1) {
            const checkRightInRight = $.inArray(
                rightAnswer,
                correctAnswers.right,
            );

            if (checkRightInRight > -1) isCorrect = true;
        }

        if (checkLeftInLeft < 0) {
            const chekLeftInRight = $.inArray(leftAnswer, correctAnswers.right);

            if (chekLeftInRight > -1) {
                const checkRightInLeft = $.inArray(
                    rightAnswer,
                    correctAnswers.left,
                );

                if (checkRightInLeft > -1) isCorrect = true;
            }
        }

        $questionWrapper.addClass("is-checked");

        if (isCorrect) {
            roomStatus = "is-status-completed";

            const onSuccess = () => {
                $questionWrapper.addClass("is-correct is-completed");
                $("input").prop("readonly", isCorrect);
            };

            const onError = () => {};

            playerAnswer.left = leftAnswer;
            playerAnswer.right = rightAnswer;

            saveFinalRoomAnswers(roomID, playerAnswer)
                .then(onSuccess)
                .catch(onError);
        } else {
            $questionWrapper.addClass("is-incorrect");
            $el.prop("disabled", false);
        }

        $el.removeClass("is-loading");

        maybeUpdateRoomStatus(roomID, roomStatus);
    }
}
